(function () {
  'use strict';

  /* ── CUSTOM CURSOR ── */
  var cur  = document.getElementById('hb-cursor');
  var ring = document.getElementById('hb-cursor-ring');
  if (cur && ring) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px';
      cur.style.top  = my + 'px';
    });
    (function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    })();
    document.querySelectorAll('.hb-btn, .hb-dot, .hb-rcard').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        ring.style.width = '60px'; ring.style.height = '60px';
        ring.style.borderColor = 'rgba(168,134,90,.7)';
      });
      el.addEventListener('mouseleave', function () {
        ring.style.width = '36px'; ring.style.height = '36px';
        ring.style.borderColor = 'rgba(168,134,90,.4)';
      });
    });
  }

  /* ── SMOKE RENDERER ── */
  function initSmoke(canvas) {
    var ctx = canvas.getContext('2d');
    var d   = canvas.dataset;
    var baseColor = d.color   || '255,250,244';
    var bgColor   = (d.bg && d.bg !== 'null') ? d.bg : null;
    var count   = parseInt(d.count)     || 7;
    var opacity = parseFloat(d.opacity) || 0.45;
    var amp     = parseFloat(d.amp)     || 0.12;
    var speed   = parseFloat(d.speed)   || 0.003;
    var W, H, particles = [], t = 0, raf = null;

    function resize() {
      W = canvas.width  = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
      build();
    }
    function build() {
      particles = [];
      for (var i = 0; i < count; i++) {
        particles.push({
          x:     W * (0.15 + (i / count) * 0.7),
          phase: (i / count) * Math.PI * 2,
          width: 16 + Math.random() * 42,
          spd:   0.55 + Math.random() * 0.65,
          op:    0.07 + Math.random() * opacity
        });
      }
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      if (bgColor) { ctx.fillStyle = bgColor; ctx.fillRect(0, 0, W, H); }
      t += speed;
      particles.forEach(function (p) {
        ctx.beginPath();
        var first = true;
        for (var s = 0; s <= 80; s++) {
          var y    = H - (s / 80) * H;
          var prog = s / 80;
          var wave = Math.sin(t * p.spd + p.phase + prog * Math.PI * 3) * W * amp * prog;
          var x    = p.x + wave + Math.sin(t * 0.3 + p.phase) * W * 0.05;
          if (first) { ctx.moveTo(x, y); first = false; } else { ctx.lineTo(x, y); }
        }
        var g = ctx.createLinearGradient(0, H, 0, 0);
        g.addColorStop(0,    'rgba(' + baseColor + ',0)');
        g.addColorStop(0.18, 'rgba(' + baseColor + ',' + p.op + ')');
        g.addColorStop(0.6,  'rgba(' + baseColor + ',' + (p.op * 0.8) + ')');
        g.addColorStop(1,    'rgba(' + baseColor + ',0)');
        ctx.strokeStyle = g;
        ctx.lineWidth   = p.width;
        ctx.lineCap     = 'round';
        ctx.lineJoin    = 'round';
        ctx.stroke();
      });
      raf = requestAnimationFrame(draw);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { if (!raf) draw(); }
        else { cancelAnimationFrame(raf); raf = null; }
      });
    }).observe(canvas);
    new ResizeObserver(resize).observe(canvas);
    resize();
  }
  document.querySelectorAll('canvas.hb-smoke').forEach(initSmoke);

  /* ── PARALLAX ── */
  function onScroll() {
    var scrollY = window.scrollY;
    document.querySelectorAll('.hb-parallax').forEach(function (el) {
      var spd = parseFloat(el.dataset.speed) || 0;
      el.style.transform = 'translateY(' + (scrollY * spd) + 'px)';
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ── WORD REVEAL — set stagger delays ── */
  document.querySelectorAll('.word-reveal').forEach(function (el) {
    el.querySelectorAll('.wr-word span').forEach(function (span, i) {
      span.style.transitionDelay = (i * 0.055) + 's';
    });
  });

  /* ── SCROLL REVEAL ── */
  var revObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      revObs.unobserve(e.target);
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.fu, .word-reveal').forEach(function (el) {
    revObs.observe(el);
  });

  // Hero fires immediately
  setTimeout(function () {
    document.querySelectorAll('.hb-s1 .fu, .hb-s1 .word-reveal').forEach(function (el, i) {
      setTimeout(function () { el.classList.add('in'); }, 200 + i * 150);
    });
  }, 100);

  /* ── PROCESS SLIDER ── */
  var track  = document.getElementById('hbTrack');
  var dots   = document.querySelectorAll('.hb-dot');
  var steps  = document.querySelectorAll('.hb-step');
  var active = 0;
  var autoInterval;

  function goTo(i) {
    active = i;
    var stepW = steps[0] ? steps[0].offsetWidth : 320;
    track.style.transform = 'translateX(-' + (i * stepW) + 'px)';
    steps.forEach(function (s, j) { s.classList.toggle('active', j === i); });
    dots.forEach(function (d, j)  { d.classList.toggle('active', j === i); });
  }

  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      clearInterval(autoInterval);
      goTo(parseInt(d.dataset.i));
      startAuto();
    });
  });

  function startAuto() {
    autoInterval = setInterval(function () {
      goTo((active + 1) % steps.length);
    }, 8000);
  }
  if (steps.length) startAuto();

  /* ── COUNTER ANIMATION ── */
  function animCounter(el) {
    var target = parseInt(el.dataset.target) || 0;
    var suffix = target >= 100 ? '+' : '';
    var start  = performance.now();
    var dur    = 1800;
    function step(now) {
      var p    = Math.min((now - start) / dur, 1);
      var ease = 1 - Math.pow(1 - p, 3);  
      el.textContent = Math.round(ease * target) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counterObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animCounter(e.target); counterObs.unobserve(e.target); }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.hb-counter').forEach(function (el) { counterObs.observe(el); });

})();
